/** Statement copy in Arabic. Mirrors `../../en/home/statement.js` key for key. */

export const STATEMENT = {
  headline: [
    { text: 'أنشئ منظمتك في ', muted: true },
    { text: 'دقائق،', muted: true, mark: true },
    { text: ' وادعُ فريقك، ', muted: true },
    { text: 'وكل حجز قاعة وزائر وموافقة يظهر في ' },
    { text: 'جدول واحد مشترك.', mark: true },
  ],
  avatars: [
    { initials: 'SH', tone: 'blue' },
    { initials: 'OF', tone: 'teal' },
    { initials: 'NA', tone: 'orange' },
  ],
  text: 'لكل دور لوحته وتسجيل دخوله: يحجز فريقك القاعات والاجتماعات، ويسجّل الاستقبال دخول الزوار وخروجهم، وتوافق الموارد البشرية على الأعضاء والحجوزات، ويدير المسؤولون القاعات والمقاعد والإعدادات.',
  pills: [
    {
      icon: 'building',
      tone: 'blue',
      title: 'تم إنشاء المنظمة',
      meta: 'Cloudgate · قبل دقيقتين',
    },
    {
      icon: 'calendar',
      tone: 'teal',
      title: 'تم حجز قاعة',
      meta: 'Atlas · الخميس 10:00 ص',
    },
    {
      icon: 'check',
      tone: 'orange',
      title: 'تمت الموافقة على الحجز',
      meta: 'من الموارد البشرية · الآن',
    },
  ],
}
